import { MINUTES_IN_DAY, MINUTES_IN_WEEK, DayOfWeek } from "./types";

export const normalizeMinutes = (
  minutes: number,
  amount: typeof MINUTES_IN_WEEK | typeof MINUTES_IN_DAY,
  returnZero = true
): number => {
  const result = (minutes >= 0 ? minutes : amount + minutes) % amount;
  return result === 0 && !returnZero ? amount : result;
};

export const shiftDayOfWeek = (oldDay: DayOfWeek, newDay: DayOfWeek): number => (newDay - oldDay) * MINUTES_IN_DAY;
export const shiftMinutes = (oldTime: { hours: string; minutes: string }, newTime: string): number => {
  const [hours, minutes] = newTime.split(":").map(i => Number(i));
  return (hours - Number(oldTime.hours)) * 60 + minutes - Number(oldTime.minutes);
};

import { ListFields } from "@/types";

export const useSelectTimeRange = () => {
  const RANGE_12_HOURS = 12;
  const RANGE_24_HOURS = 24;
  const RANGE_STEPS = ["00", "15", "30", "45"];
  const getHoursString = (hour: number): string => (hour > 9 ? `${hour}` : `0${hour}`);

  const range24HoursOptions: ListFields = new Array(RANGE_24_HOURS).fill("").reduce((acc, _, i) => {
    const hour = getHoursString(i);
    RANGE_STEPS.forEach(s => acc.push({ text: `${hour}:${s}`, value: `${hour}:${s}` }));
    return acc;
  }, []);
  const range12HoursOptions: ListFields = range24HoursOptions.map(o => {
    let hours = parseInt(o.text.slice(0, 2));
    const hours12 = hours % RANGE_12_HOURS || RANGE_12_HOURS;
    const mins = o.text.slice(-2);
    const AMPM = hours >= RANGE_12_HOURS ? "PM" : "AM";

    return {
      text: `${getHoursString(hours12)}:${mins} ${AMPM}`,
      value: o.value,
    };
  });

  return {
    range12HoursOptions,
    range24HoursOptions,
  };
};
